import { rot13Cipher } from 'utilities/string';
// runtime configuration passed down by the app
const _LOOM_ = getConfig();

export const NODE_ENV = _LOOM_.NODE_ENV;
export const CLIENT_LOG_LEVEL = _LOOM_.CLIENT_LOG_LEVEL;
export const SENTRY_RELEASE = _LOOM_.SENTRY_RELEASE;
export const BILLING_RECAPTCHA_SITE_KEY = _LOOM_.BILLING_RECAPTCHA_SITE_KEY;
export const GOOGLE_API_CLIENT_ID = _LOOM_.GOOGLE_API_CLIENT_ID;
export const CHROME_EXTENSION_ID = _LOOM_.CHROME_EXTENSION_ID;
export const CLOUDFRONT_URI = _LOOM_.CLOUDFRONT_URI;
export const AVSERVER_CLOUDFRONT_URI = _LOOM_.AVSERVER_CLOUDFRONT_URI;
export const ANON_COOKIE_DOMAIN = _LOOM_.ANON_COOKIE_DOMAIN;
export const LOOM_BARE_URI = _LOOM_.LOOM_BARE_URI;
export const LOOM_URI = _LOOM_.LOOM_URI;
export const LOOM_RECORD_WS_URI = _LOOM_.LOOM_RECORD_WS_URI;
export const LOOM_DESKTOP_PROTOCOL = _LOOM_.LOOM_DESKTOP_PROTOCOL;
export const LOOM_VERSION = _LOOM_.LOOM_VERSION;
export const MUX_ENV_KEY = _LOOM_.MUX_ENV_KEY;
export const ELEVIO_ACCOUNT_ID = _LOOM_.ELEVIO_ACCOUNT_ID;
export const DATADOG_CLIENT_KEY = _LOOM_.DATADOG_CLIENT_KEY;
export const DATADOG_RUM_APPLICATION_ID = _LOOM_.DATADOG_RUM_APPLICATION_ID;
export const DATADOG_RUM_CLIENT_TOKEN = _LOOM_.DATADOG_RUM_CLIENT_TOKEN;
export const DATADOG_RUM_SAMPLE_RATE = _LOOM_.DATADOG_RUM_SAMPLE_RATE;
export const PUSH_SERVER_PUBLIC_KEY = _LOOM_.PUSH_SERVER_PUBLIC_KEY;
export const STRIPE_PUBLIC_KEY = _LOOM_.STRIPE_PUBLIC_KEY;
export const INTEGRATIONS_APP_URL = _LOOM_.INTEGRATIONS_APP_URL;
export const LOOM_SDK_API_KEY = _LOOM_.LOOM_SDK_API_KEY;
export const MAX_ATTACHMENT_SIZE_IN_BYTES = Number(
  _LOOM_.MAX_ATTACHMENT_SIZE_IN_BYTES
);

function getConfig() {
  if (!window['_LOOM_']) {
    return {};
  }

  try {
    return JSON.parse(decodeURIComponent(rot13Cipher(window['_LOOM_'])));
  } catch (e) {
    console.error(e, { encodedString: window['_LOOM_'] });
  }

  return {};
}

// clearing the state to make it a tiny lil baby bit more difficult to find it
delete window['_LOOM_'];
